import { useHistory } from "react-router-dom";
import useUserInfo from "../../../../../hooks/useUserInfo";
import {
  ArrowIcon,
  MainWalletTitleButtonWrapper,
  MainWalletWrapper,
  PointSection,
  PointText,
  SeedAmount,
  TierContainer,
  WalletContent,
  WalletHeader,
  WalletTitle,
} from "./styles";
import TierItem from "./user-wallet-card";
import PubQR from "../pub-qr";

const TIER_MAP = {
  BRONZE: "브론즈",
  SILVER: "실버",
  GOLD: "골드",
  PLATINUM: "플레티넘",
  DIAMOND: "다이아몬드",
  MASTER: "마스터",
} as const;

const formatTier = (tier: string | undefined): string => {
  if (!tier) return "브론즈";
  return TIER_MAP[tier as keyof typeof TIER_MAP] || "";
};

const UserWallet = ({
  onClickInfo,
  onClickQr,
  qrValue,
}: {
  onClickInfo: () => void;
  onClickQr: () => void;
  qrValue: string;
}) => {
  const { user } = useUserInfo();
  const history = useHistory();

  // 계산된 값들
  const seedAmount = user?.seed ? user.seed.toLocaleString() : "0";
  const pointAmount = user?.point ? (user.point / 10000).toLocaleString() : "0";

  // 티어/랭킹 관련 계산된 값들
  const tierName = formatTier(user?.ranking?.tier);
  const tierScore = user?.ranking
    ? ((user.ranking.point || 0) / 100).toFixed(2)
    : "0";
  const nationalRank = user?.ranking?.ranking || 0;
  const pointDiff = user?.ranking?.pointDiff || 0;
  const rankDiff = user?.ranking?.rankDiff || 0;

  // 클릭 핸들러
  const handleWalletClick = () => history.push("/wallet");
  const handleRankClick = () => history.push("/rank");

  return (
    <MainWalletWrapper>
      <MainWalletTitleButtonWrapper>
        <div
          className="title"
          onClick={(e) => {
            onClickInfo();
          }}
        >
          INFO
        </div>
        <div
          className="qr-icon-wrapper"
          onClick={(e) => {
            onClickQr();
          }}
        >
          <PubQR qrValue={JSON.stringify(qrValue)} width="93%" height="93%" />
        </div>
      </MainWalletTitleButtonWrapper>

      <WalletHeader>
        <WalletTitle>보유래빗</WalletTitle>
        <WalletContent>
          <SeedAmount onClick={handleWalletClick}>
            {seedAmount} Rabbit
          </SeedAmount>

          <PointSection>
            <PointText>
              매장 이용권 <span>{pointAmount} E</span>
            </PointText>
            <ArrowIcon
              src="image-web/home/right-arrow.svg"
              alt="arrow"
              onClick={handleWalletClick}
            />
          </PointSection>
        </WalletContent>
      </WalletHeader>

      <TierContainer onClick={handleRankClick}>
        <TierItem
          imageSrc={`/image-web/rank/${user?.ranking?.tier || "BRONZE"}.png`}
          imageAlt={user?.ranking?.tier || "tier"}
          name={tierName}
          value={tierScore}
          unit="점"
          diff={pointDiff / 100}
          flex={1.2}
        />
        <TierItem
          imageSrc="/image-web/home/all-rank.png"
          imageAlt="rank"
          name="전국순위"
          value={nationalRank.toString()}
          unit="등"
          diff={rankDiff}
          flex={1}
        />
      </TierContainer>
    </MainWalletWrapper>
  );
};

export default UserWallet;
